/** Go-live checklist copy, English only. */
export const g = {
  title: "Go-live checklist",
  intro: "What is left before your gym goes live. Helmr fills this in as the work is done; your Helmr contact runs the final check.",
  doneOf: (done: number, total: number) => `${done} of ${total} items done`,
  live: "Your gym is live",
  liveSince: (when: string) => `Went live ${when}.`,
  leftTitle: (n: number) => `${n} item${n === 1 ? "" : "s"} still need${n === 1 ? "s" : ""} attention`,
  allGreen: "Every item is green. Your Helmr contact can run the go-live check.",
  progress: "Checklist progress",
  required: "Required",
  optional: "Optional, can be waived with a reason",
  state: { ok: "Done", ticked: "Ticked", red: "Needs attention", not_started: "Not started" },
  tickedAt: (when: string, reason: string) => `Ticked ${when}: ${reason}`,
  tick: "Tick with a reason",
  tickReason: "Why is this item done or not needed?",
  tickSave: "Save tick",
  tickCancel: "Cancel",
  terminals: "Terminals",
  noneUnmapped: "no unmapped users",
  reserved: "Reserved (device master)",
  empty: { title: "Nothing to show", body: "The checklist could not be built for this gym." },
  readOnly: "You can see the checklist. Ticking an item needs the go-live edit permission.",
};
